const formatBody = values => {
  const f = x => (x === '' || typeof x === 'undefined' ? null : x);
  // company is read-only on the API model, which returns it as an object while
  // the form only ever sets companyId. Dropped here so an API object can never
  // be sent back, whatever seeds the form.
  const { company, ...rest } = values;
  const valuesToSave = {
    ...rest,
    name: f(rest.name),
    email: f(rest.email),
    addressLineOne: f(rest.addressLineOne),
    city: f(rest.city),
    phone: f(rest.phone),
    addressLineTwo: f(rest.addressLineTwo),
    state: f(rest.state),
    zipCode: f(rest.zipCode),
    notes: f(rest.notes)
  };
  return valuesToSave;
};

export default formatBody;
